<template>
    <div>
        <Navbar />
        <div class="page-title-area">
            <div class="container">
                <div class="page-title-content">
                    <h1>Category: Startup</h1>
                    <ul>
                        <li><router-link to="/">Home</router-link></li>
                        <li><router-link to="/blog-grid">Blog</router-link></li>
                        <li>Startup</li>
                    </ul>
                </div>
            </div>
        </div>
        <BlogCategory />
        <FooterStyleTwo />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import BlogCategory from '../BlogCategory/BlogCategory'
import FooterStyleTwo from '../Layouts/FooterStyleTwo'

export default {
    name: 'BlogCategoryPage',
    components: {
        Navbar,
        BlogCategory,
        FooterStyleTwo,
    }
}
</script>